module.exports = __webpack_public_path__ + "c753172d0899409b87ebabdab9208281.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-panel-420.webp.png
// module id = 475
// module chunks = 0